import appDateTimeService from '@/services/appDateTimeService';
import appContent from '@/services/content/appContent.typed';
import type {AutoDeliveryBase} from '@/types/icc/autoDeliveryDetails';
import stringUtils from '@/utils/stringUtils';

import AutoDeliveryDcxStatusTitle from '../AutoDeliveryDcxStatusTitle';

type AutoDeliveryDcxNextDeliveryDateRangeTitleProps = {
    className?: string;
    nextDeliveryDate: AutoDeliveryBase['nextDeliveryDate'];
    maxNextDeliveryDate?: AutoDeliveryBase['maxNextDeliveryDate'];
};

const AutoDeliveryDcxNextDeliveryDateRangeTitle = ({
    className,
    nextDeliveryDate,
    maxNextDeliveryDate,
}: AutoDeliveryDcxNextDeliveryDateRangeTitleProps) => {
    if (nextDeliveryDate === null) return null;

    const {nextDeliveryDaysRangeLabel} = appContent.getAutoDeliveryContent().dashboardContent || {};

    const text = stringUtils.formatString(
        nextDeliveryDaysRangeLabel,
        appDateTimeService.getLocalizedDayAndShortMonth(nextDeliveryDate),
        appDateTimeService.getLocalizedDayAndShortMonth(maxNextDeliveryDate)
    );

    return <AutoDeliveryDcxStatusTitle className={className} title={text} renderAs='p' />;
};

export default AutoDeliveryDcxNextDeliveryDateRangeTitle;
